import { Either } from "src/base/Either";
import { Failure } from "src/base/Failure";
import { UseCase } from "src/base/UseCase";
import { IUser } from "src/features/account/data/models/user";
import { IOrthodontistRepository } from "../../data/repositories/orthodontistRepository";

export class DeleteOrthodontist extends UseCase<DeleteOrthodontistParams, boolean>{
    private repository: IOrthodontistRepository
    constructor(repository: IOrthodontistRepository) {
        super()
        this.repository = repository
    }

    call(params: DeleteOrthodontistParams): Promise<Either<Failure, boolean>> {
        return this.repository.deleteOrthodontist(params.id)
    }

}

export class DeleteOrthodontistParams {
    id: string
    constructor(id: string) {
        this.id = id
    }
}